export default __webpack_public_path__ + "129d710658d602ac8d9e63888595edca.svg";